import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  BottomPanelTabs,
  ResizeBottomPanelPayload,
  RightPanelTabs,
} from '../locations-skeleton.component';

export const SkeletonGeneralActions = createActionGroup({
  source: 'SKELETON GENERAL',
  events: {
    initializeContainerDimensions: props<{
      totalHeight: number,
      totalWidth: number
    }>(),
    initializeContainerDimensionsSuccess: emptyProps(),
    initializeContainerDimensionsError: emptyProps(),
    toggleResizing: emptyProps(),
  },
});

export const SkeletonRightPanelActions = createActionGroup({
  source: 'SKELETON RIGHT PANEL',
  events: {
    selectRightPanelTab: props<{ payload: RightPanelTabs }>(),
    userSelectRightPanelTab: props<{ payload: RightPanelTabs, skipUserCheck?: boolean }>(),
    toggleRightPanel: emptyProps(), // updates store value
    userToggleRightPanel: props<{ skipUserCheck?: boolean }>(), // triggers effect
    resizeRightPanel: props<{  totalWidth: number, rightPanelWidth: number }>(),
    setRightPanelRelativeWidth: props<{ rightPanelRelativeWidth: number }>(),
    setUnsavedChangesInRightPanelTab: props<{ unsavedChangesInRightPanelTab: boolean }>(),
  },
});

export const SkeletonBottomPanelActions = createActionGroup({
  source: 'SKELETON BOTTOM PANEL',
  events: {
    selectBottomPanelTab: props<{ payload: BottomPanelTabs }>(), // updates store value
    userSelectBottomPanelTab: props<{ payload: BottomPanelTabs, skipUserCheck?: boolean }>(), // triggers effect
    toggleBottomPanel: emptyProps(), // updates store value
    userToggleBottomPanel: props<{ skipUserCheck?: boolean }>(), // triggers effect
    resizeBottomPanel: props<{ payload: ResizeBottomPanelPayload }>(),
    setBottomPanelRelativeHeight: props<{ bottomPanelRelativeHeight: number }>(),
    setUnsavedChangesInBottomPanelTab: props<{ unsavedChangesInBottomPanelTab: boolean }>()
  },
});
